import React from 'react';
import { Grid, Button, FormControl, DialogActions, DialogContent } from '@mui/material';
import { DialogCustom, DialogTitleCustom, FieldWrap } from '@tap/mui-ui';
import { LoadingButton } from '@mui/lab';
import { ICancelDialogResult, IDialogProps } from '@tap/tap-ui';
import { IApiIssue, issueService } from '@tap/data-providers';
import { useDocuemtnSchema, useDynamicDocumentForm, DocumentForm, useComment, CommentEditor } from '@tap/doc-ui';


/*
*   Диалог с динамической формой
*/


type IDynamicFormDialogProps = IDialogProps<{ issue: IApiIssue, hiddenDocumentData?: object, formProps: any }, ICancelDialogResult>;

export default function DynamicFormDialog({
    data,
    isOpen,
    handleClose,
}: IDynamicFormDialogProps) {

    const commentState = useComment({ documentKeys: [data.issue.issueKey], actionCode: 'issue__assign' });

    const documentCode = data.issue.issueKey.split('-')[0];
    const documentSchema = useDocuemtnSchema(documentCode);

    const documentFormProps = useDynamicDocumentForm({
        documentSchema,
        documentData: data.issue,
        fields: data.formProps.fields,
        handleSubmit: (values) => {
            return Promise.resolve()
                .then(() => {
                    return issueService.updateIssue(data.issue.issueKey, { ...values, ...(data.hiddenDocumentData || {}) });
                })
                .then(() => {
                    return commentState.addComment();
                })
                .then(() => {
                    handleClose({ isCancel: false });
                });
        },
    });

    const handleCancel = () => {
        handleClose({ isCancel: true });
    }


    return (
        <DialogCustom
            handleClose={handleCancel}
            open={isOpen}
        >
            <DialogTitleCustom
                primaryText={data.formProps.title}
            />
            <DialogContent>

                <Grid
                    item
                    container
                    spacing={2}
                    alignItems='stretch'
                >
                    {/* Форма */}
                    <DocumentForm {...documentFormProps} />

                    {/* Комментарий */}
                    <FieldWrap label={'Комментарий'}>
                        <FormControl sx={{ width: '100%' }}>
                            <CommentEditor {...commentState} />
                        </FormControl>
                    </FieldWrap>
                </Grid>
            </DialogContent>
            <DialogActions >
                <Grid container justifyContent='flex-end'>

                    {/* Кнопка - Назначить*/}
                    <LoadingButton
                        loading={documentFormProps.formik.isSubmitting}
                        disableElevation
                        type='button'
                        variant='contained'
                        color='primary'
                        onClick={documentFormProps.formik.submitForm}
                        sx={{ mr: 2 }}
                    >
                        {data.formProps.button}
                    </LoadingButton>

                    {/* Кнопка - Отмена*/}
                    <Button
                        disableElevation
                        type='button'
                        variant='text'
                        color='primary'
                        onClick={handleCancel}
                    >
                        Отмена
                    </Button>
                </Grid>
            </DialogActions>
        </DialogCustom >
    );
}
